import DocumentFinancialIconPath from "@ingka/ssr-icon/paths/document-financial";

export default DocumentFinancialIconPath;
